
export default class HallAppConst {
  static readonly ERROR_IN_FORM: string = 'Verifique os campos destacados em vermelho e faça as correções necessárias.';
  static readonly GENERIC_ERROR: string = 'Tente novamente mais tarde. Se o problema continuar, entre em contato com o suporte.';
  static readonly AGENDAMENTO_URL: string = 'https://agendamento.hallapp.com.br'
}
